export default [12, 14, 20, 20, 24, 32, 48, 64, 96];
